import { configureStore } from "@reduxjs/toolkit";
import { combinedReducer } from "../slices";
const store = configureStore({
    reducer: combinedReducer,
});
export default store;
